import { useMemo } from 'react';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import gregorian from 'react-date-object/calendars/gregorian';
import persian_fa from 'react-date-object/locales/persian_fa';
import './JalaliDatePicker.css';

const ASCII_DIGITS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

/**
 * Convert a Gregorian `YYYY-MM-DD` string into a Persian calendar DateObject
 * so the picker displays it in Jalali.
 */
const toPersianDateObject = (value) => {
    if (!value) return null;
    try {
        const date = new DateObject(value);
        date.calendar = persian;
        return date;
    } catch {
        return null;
    }
};

/**
 * Convert a picked Persian DateObject back to a Gregorian `YYYY-MM-DD`
 * string. The picker reuses its DateObject internally, so we work on a
 * clone to avoid mutating its state.
 */
const toGregorianString = (date) => {
    if (!date) return null;
    try {
        const clone = new DateObject(date);
        clone.digits = ASCII_DIGITS;
        return clone.convert(gregorian).format('YYYY-MM-DD');
    } catch {
        return null;
    }
};

/**
 * Jalali (Persian) date picker.
 *
 * Props:
 *   - value:   Gregorian `YYYY-MM-DD` string (or empty)
 *   - onChange: called with the selected Gregorian `YYYY-MM-DD` string
 *               (or null when cleared)
 *   - plus any react-multi-date-picker DatePicker props
 */
export const JalaliDatePicker = ({
    value,
    onChange,
    isDisabled,
    disabled,
    className = '',
    inputClass = '',
    placeholder = 'انتخاب تاریخ',
    ...props
}) => {
    const persianValue = useMemo(() => toPersianDateObject(value), [value]);

    const handleChange = (date) => {
        onChange?.(toGregorianString(date));
    };

    return (
        <div className={`jalali-date-picker ${className}`}>
            <DatePicker
                calendar={persian}
                locale={persian_fa}
                value={persianValue}
                onChange={handleChange}
                format="YYYY/MM/DD"
                disabled={isDisabled || disabled}
                placeholder={placeholder}
                inputClass={`jalali-date-picker__input ${inputClass}`.trim()}
                containerClassName="jalali-date-picker__container"
                {...props}
            />
        </div>
    );
};

export default JalaliDatePicker;
